<template>
  <div
    class="tw-transition tw-rounded-3xl  tw-mb-2 tw-border tw-border-gray tw-text-dark dark:tw-text-dm-dark dark:tw-border-dm-gray tw-p-6 tw-flex tw-items-center tw-gap-5 hover:tw-shadow dark:hover:tw-shadow-dm hover:tw-border-transparent hover:tw-text-primary dark:hover:tw-text-dm-primary"
  >
    <div class="tw-flex-1">
      <a
        class="tw-font-medium tw-tracking-wide tw-leading-5"
        target="_blank"
        :href="`/foreigners/${foreigner.id}/questionnaires/${questionnaire.id}`"
      >
        {{ questionnaire.survey_type_name }}
      </a>
    </div>
    <div class="tw-w-40 tw-flex tw-items-start">
      <i-badge :type="questionnaire.completed ? 'success' : 'default'">
        {{ questionnaire.completed ? 'Completed' : 'Not completed' }}
      </i-badge>
    </div>
    <div class="tw-w-32">
      <el-switch
        v-if="submitted || $isInRole(['HR', 'AGENCY'])"
        :model-value="submitted"
        :disabled="!$isInRole(['ADMIN', 'CONSULTANT'])"
        @change="updateSubmitted"
      />
      <i-confirm-popover
        v-else
        :cancel-text="$t('common.actions.cancel')"
        :submit-text="$t('common.actions.confirm')"
        @submit="() => updateSubmitted(true)"
      >
        <template #reference>
          <el-switch
            :value="submitted"
          />
        </template>
        <template #content>
          <div slot="content">
            {{ $t('foreigners.questionnaires.submit_confirmation') }}
          </div>
        </template>
      </i-confirm-popover>
    </div>
    <div
      v-if="$isInRole(['ADMIN', 'CONSULTANT'])"
      class="tw-flex tw-gap-3 tw-w-40"
    >
      <el-tooltip
        :content="questionnaire.submitted ? $t('quest.export_hint') : $t('quest.unable_export_hint')"
      >
        <div>
          <i-button
            type="default"
            is-icon
            :is-disabled="!questionnaire.submitted"
            @click.stop.prevent="isQuestionnaireFormStudioDialogOpen = true"
          >
            <icon-form-studio />
          </i-button>
        </div>
      </el-tooltip>


      <i-confirm-popover
        :cancel-text="$t('common.actions.cancel')"
        :submit-text="$t('common.actions.delete')"
        @submit="deleteQuestionnaire"
      >
        <template #reference>
          <i-button
            is-icon
            :is-loading="isDeleting"
          >
            <icon-trash />
          </i-button>
        </template>
        <template #content>
          <div>
            {{ $t('foreigners.questionnaires.delete_confirmation') }}
            <strong>
              {{ questionnaire.survey_type_name }}
            </strong>
          </div>
        </template>
      </i-confirm-popover>
    </div>

    <QuestionnaireFormStudioDialog
      :is-open="isQuestionnaireFormStudioDialogOpen"
      :questionnaire="questionnaire"
      @close="isQuestionnaireFormStudioDialogOpen = false"
    />
  </div>
</template>

<script>
import QuestionnaireFormStudioDialog from '@/components/Dialogs/QuestionnaireFormStudioDialog.vue';
import { mapState } from 'vuex';

export default {
  name: 'ForeignersQuestionnairesListItem',
  components: {
    QuestionnaireFormStudioDialog,
  },

  props: {
    questionnaire: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isDeleting: false,
      submitted: false,
      isQuestionnaireFormStudioDialogOpen: false,
    };
  },

  computed: {
    ...mapState({
      foreigner: (state) => state.v2.admin.foreigners.foreigner.foreigner,
    }),
  },

  watch: {
    'questionnaire.submitted': {
      immediate: true,
      handler(submitted) {
        this.submitted = submitted;
      },
    },
  },

  methods: {
    async updateSubmitted(submitted) {
      this.submitted = Boolean(submitted);
      await this.$store.dispatch('v2/admin/foreigners/foreigner/updateQuestionnaire', {
        foreignerId: this.foreigner.id,
        questionnaireId: this.questionnaire.id,
        payload: {
          submitted,
        },
      });
    },
    async deleteQuestionnaire() {
      this.isDeleting = true;
      await this.$store.dispatch('v2/admin/foreigners/foreigner/deleteQuestionnaire', {
        foreignerId: this.foreigner.id,
        questionnaireId: this.questionnaire.id,
      });
      this.isDeleting = false;
    },
  },
};
</script>
